module.exports = __webpack_public_path__ + "static/banner-mobile-a36051a1c90d663800d3a956b0af61a1.png";